import { render } from "./EpoxyGuide.vue?vue&type=template&id=ff2394ba&scoped=true"
import script from "./EpoxyGuide.vue?vue&type=script&lang=js"
export * from "./EpoxyGuide.vue?vue&type=script&lang=js"

import "./EpoxyGuide.vue?vue&type=style&index=0&id=ff2394ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff2394ba"]])

export default __exports__